import {
  Accordion,
  AccordionContent,
  AccordionHeading,
  Box,
  Flex,
} from '@moonpig/launchpad-components'
import React, { FC, useState } from 'react'
import { IconSystemDetails } from '@moonpig/launchpad-assets'
import { styled } from '@moonpig/launchpad-utils'
import { AccordionSection } from '../../types'
import { useProductDetailsLocaleText } from './ProductDetails.locale'
import { useProductDescriptionQuery } from '../../queries/useProductDescriptionQuery'
import { createTrackAccordionSectionClick } from './createTrackAccordionSectionClick'
import { useProductStore } from '../../contexts/product'
import { ImportedHTML } from '../../components/ImportedHTML'

const StyledContainer = styled(Box)`
  animation: fadeIn 400ms forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0;
      transform: translateY(50%);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const ProductDetailsModule: FC = () => {
  const [openSections, setOpenSections] = useState<AccordionSection[]>([])
  const localiseText = useProductDetailsLocaleText()
  const [
    {
      product: { id: productId },
    },
  ] = useProductStore()
  const description = useProductDescriptionQuery({
    productId,
  })

  if (!description) {
    return null
  }

  const sectionDescription = {
    title: <Box ml={6}>{localiseText('product_details')}</Box>,
    sectionType: AccordionSection.DESCRIPTION,
    icon: <IconSystemDetails width="28px" aria-hidden />,
    render: <ImportedHTML html={description} />,
  }

  return (
    <StyledContainer mb={9} data-testid="module-product-details">
      <Accordion
        type="multiple"
        defaultValue={[]}
        onValueChange={(updatedSections: AccordionSection[]) => {
          createTrackAccordionSectionClick({
            currentSections: openSections,
            updatedSections,
            productId,
          })
          setOpenSections(updatedSections)
        }}
      >
        <AccordionContent
          heading={
            <AccordionHeading level="h2">
              <Flex>
                {sectionDescription.icon}
                {sectionDescription.title}
              </Flex>
            </AccordionHeading>
          }
          value={sectionDescription.sectionType}
        >
          {sectionDescription.render}
        </AccordionContent>
      </Accordion>
    </StyledContainer>
  )
}
